"use client";

import { useEffect, useState, ReactNode } from "react";
import { motion, AnimatePresence } from "framer-motion";
import SplashScreen from "@/components/splashScreenLogo";

export default function AppContainer({ children }: { children: ReactNode }) {
  const [showSplash, setShowSplash] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setShowSplash(false), 3000); // splash duration
    return () => clearTimeout(timer);
  }, []);

  return (
    <div style={{ position: "relative" }}>
      <AnimatePresence>
        {showSplash && (
          <motion.div
            key="splash"
            initial={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 1 }}
            style={{ position: "absolute", inset: 0, zIndex: 50 }}
          >
            <SplashScreen />
          </motion.div>
        )}
      </AnimatePresence>

      <motion.div
        key="content"
        initial={{ opacity: 0 }}
        animate={{ opacity: showSplash ? 0 : 1 }}
        transition={{ duration: 1, delay: showSplash ? 1 : 0 }}
        style={{ minHeight: "100vh" }}
      >
        {children}
      </motion.div>
    </div>
  );
}
